'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const EddDash = () => {
  const {
    headersHugeNone
  } = nthHookTheme.useTheme();

  // https://github.com/narvar/nth/pull/994/files#r946119464
  const dashTheme = {
    ...headersHugeNone,
    lineHeight: headersHugeNone?.lineHeight ?? '5.5rem',
    width: '2.5rem',
    textAlign: 'center',
    fontSize: '3rem',
    fontWeight: '700',
    margin: '0.5rem 0 0 0'
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: dashTheme
  }, "-");
};
var EddDashWithTheme = nthHookTheme.withThemeProvider(EddDash, {
  themeTokens: ['headersHugeNone']
});

exports.EddDash = EddDash;
exports["default"] = EddDashWithTheme;
